<template>
  <div class="main-container" ref="containerRef">
    <!-- 1. 全局虚线 SVG -->
    <svg class="dash-line-svg"
         :viewBox="`0 0 ${containerW} ${containerH}`">
      <line v-for="(l,i) in dashLines"
            class="dash-line"
            :key="i"
            :x1="l.x1"
            :y1="l.y1"
            :x2="l.x2"
            :y2="l.y2"
            :stroke="l.active ? '#2ca6e0' : '#cccccc'"

            stroke-dasharray="6 4"/>
    </svg>
    <!-- 左侧内容 -->
    <div class="content-col left-col">
      <div
        v-for="(item, idx) in leftModules"
        :key="`left-${idx}`"
        class="content-item"
        :class="{ active: hoverIndex === idx, 'extra-gap': idx === 1 }"
        @mouseenter="onHoverLeft(idx)"
        @mouseleave="unHover"
      >
        <h3 class="content-item-title" :ref="el=>setTextRef(el,idx)">{{ item.title }}</h3>
        <!-- 只保留一个 p，把 idx 传进去 -->
        <p class="content-item-text" >
          <span class="content-item-text-bold">{{ item.desc }}:</span>
          {{ item.content }}
        </p>
      </div>
    </div>

    <!-- 中间圆环 -->
    <div class="ring-col">
      <WptRingModules
        ref="ringRef"
        :centerImage="centerImage"
        :icons="icons"
        @ready="calcDashLines"
        @select="onselect"
        @cancel="cancelActive"
        @radius="onRadius"
      />
    </div>

    <!-- 右侧内容 -->
    <div class="content-col right-col">
      <div
        v-for="(item, idx) in rightModules"
        :key="`right-${idx}`"
        class="content-item"
        :class="{ active: hoverIndex === idx + leftModules.length }"
        @mouseenter=" onHover(idx)"
        @mouseleave="unHover"
      >
        <h3 class="content-item-title-right" :ref="el=>setTextRef(el,idx+leftModules.length)" >{{ item.title }}</h3>
        <p class="content-item-text" >
          <span class="content-item-text-bold">{{ item.desc }}:</span>
          {{ item.content }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, nextTick,watch } from 'vue'
import WptRingModules from '@/components/WptRingModules.vue'
import { debounce } from 'lodash-es'


const props = defineProps({
  centerImage: {
    type: String,
    default: 'https://website.obs.icheer.cn/icheer-web/images/WPT/rings-center.jpg'
  },
  ringModules: {
    type: Array,
    default: () => [
      { title: '交换名片', desc: '高效建立商务联系的核心功能', content: '用户间可一键互换经过实名认证的电子名片，成功交换后即互为平台好友，解锁联系方式并开启对话，可直接拨打电话、也可发起站内聊天。' },
      { title: '站内聊天', desc: '集沟通、资料共享与业务协同于一体的IM工具', content: '沟通时，可随时查看好友的公司信息和产品库，快速分享自己的产品、图片、文件或名片，并可直接记录备忘、跟进商机，实现无缝衔接。' },
      { title: '商机分享', desc: '专为撮合方设计的轻量化商机管理工具', content: '经纪人/渠道商可快速创建标准化商机表单，将供需方汇聚在同一个“商机窗口”内进行多方沟通，助力撮合者高效推动合作落地，并获得相应的价值回报。' },
      { title: '好友地图', desc: '线上线下联动的智能地图', content: '聚合展示所有平台好友的公司地理位置，并支持在好友备忘中添加特定位置，方便规划线下拜访、工厂验厂、商务洽谈或行业聚会，真正实现线上人脉资源的线下价值转化。' },
      { title: '拓客数据', desc: '全方位的数据洞察中心', content: '追踪并分析所有拓客行为数据，通过可视化图表，帮助企业清晰了解每一次拓客效果，识别高效渠道和优质人脉，从而优化营销策略，实现精细化的客情管理和资源投入。' },
      { title: '拓客工具', desc: '企业工作台的强大营销武器', content: '可一键生成带专属拓客编号的展柜/产品分享链接。当企业员工、合作伙伴或行业KOL通过分享链接产生客户咨询或成交时，系统能精准追踪业绩归属和分佣结算。' },
      { title: '厂商展柜', desc: '入驻企业的专属线上品牌展厅', content: '全面展示源头厂商的产品矩阵，以及企业资质、工厂实景、研发实力、合作案例等关键信息，是建立专业形象、赢得选品客户信任的核心阵地与对接窗口。' },
      { title: '展品大厅', desc: '平台的核心流量入口', content: '采用智能推荐算法，动态呈现优质产品与潜力新品，为采购商提供高效精准的选品发现引擎，让好产品被更多潜在客户看到，实现供需双方的高效对接。' }
    ]
  }
})

const icons = [
  'https://website.obs.icheer.cn/icheer-web/images/WPT/icons/icon8.png',
  'https://website.obs.icheer.cn/icheer-web/images/WPT/icons/icon7.png',
  'https://website.obs.icheer.cn/icheer-web/images/WPT/icons/icon6.png',
  'https://website.obs.icheer.cn/icheer-web/images/WPT/icons/icon5.png',
  'https://website.obs.icheer.cn/icheer-web/images/WPT/icons/icon4.png',
  'https://website.obs.icheer.cn/icheer-web/images/WPT/icons/icon3.png',
  'https://website.obs.icheer.cn/icheer-web/images/WPT/icons/icon2.png',
  'https://website.obs.icheer.cn/icheer-web/images/WPT/icons/icon1.png'
]

const leftModules = computed(() => props.ringModules.slice(4).reverse())
const rightModules = computed(() => props.ringModules.slice(0, 4))

/* ------------------ 虚线逻辑 ------------------ */
const containerRef = ref(null)
const containerW = ref(0)
const containerH = ref(0)
const ringRef   = ref(null)   // WptRingModules 实例
const dashLines = ref([])     // 每条线坐标
const hoverIndex = ref(-1)
const ringRadius = ref(0)
const arcPos     = ref([])   // 8 个外弧中心

const ringCanvas = ref({ x: 0, y: 0, size: 270 })   // 270 坐标系

function onRadius ({ value, pos, canvas }) {
  ringRadius.value = value
  arcPos.value     = pos
  ringCanvas.value = canvas
  /* 等圆环渲染完再算线 */
  const img = ringRef.value.el?.querySelector('image')
  if (img) {
    img.addEventListener('load', () => nextTick(onResize), { once: true })
  } else {
    nextTick(onResize)
  }
}
const blockIndexToRingIndex = computed(() => [
  ...Array(leftModules.value.length).fill(0).map((_, i) => leftModules.value.length * 2 - 1 - i),
  ...Array(rightModules.value.length).fill(0).map((_, i) => i)
])
const titleRefs = ref([])          // 保存 8 个 <h3>
const setTextRef = (el, i) => { if (el) titleRefs.value[i] = el }
function calcDashLines () {
  if (!ringRef.value?.el || !containerRef.value || !arcPos.value.length) return

  const containerRect = containerRef.value.getBoundingClientRect()
  const ringRect      = ringRef.value.el.getBoundingClientRect()

  // 正方形边长（取宽高中较小值，防止拉伸）
  const canvasSize = Math.min(ringRect.width, ringRect.height)
  const scale      = canvasSize / ringCanvas.value.size
  // 让 270×270 居中后产生的上下/左右留白对称
  const offsetX = ringRect.left - containerRect.left + (ringRect.width  - canvasSize) / 2
  const offsetY = ringRect.top  - containerRect.top + (ringRect.height - canvasSize) / 2

  dashLines.value = titleRefs.value.map((el, i) => {
    if (!el) return { x1: 0, y1: 0, x2: 0, y2: 0, active: false }

    const r = el.getBoundingClientRect()
    const isLeft = i < leftModules.value.length
    const x1 = (isLeft ? r.right : r.left) - containerRect.left + (isLeft ? 2 : -2)
    const y1 = r.bottom - containerRect.top

    const arc = arcPos.value[blockIndexToRingIndex.value[i]]
    const x2 = offsetX + arc.x * scale
    const y2 = offsetY + arc.y * scale

    return { x1, y1, x2, y2, active: hoverIndex.value === i }   // 关键
  })
}

function onselect (event) {
  if (event >= 4)
  {
    hoverIndex.value = 7 - event
  }else {
    hoverIndex.value = 4 + event
  }

}
/* 新增：hoverIndex 变化后防抖重绘 */
watch(hoverIndex, debounce(() => nextTick(calcDashLines), 16))
function onHoverLeft (index) {
  hoverIndex.value = index
  var i = 7 - index
  ringRef.value.active(i)
}

function onHover (index) {
  hoverIndex.value = index + leftModules.value.length
  ringRef.value.active(index)
}
function unHover () {
  cancelActive()
  ringRef.value.cancel()
}
function cancelActive () {
  hoverIndex.value = null
}
function onResize () {
  if (!containerRef.value) return
  const rect = containerRef.value.getBoundingClientRect()
  containerW.value = rect.width    // 用来生成 viewBox
  containerH.value = rect.height
  nextTick(calcDashLines)
}
onMounted(() => {
  window.addEventListener('resize', onResize)
  nextTick(onResize)

  /* 关键：如果当前就是手机屏，强制再算一次 */
  if (window.matchMedia('(max-width: 768px)').matches) {
    nextTick(() => window.dispatchEvent(new Event('resize')))
  }
  /* 关键：多等一帧，让图片/组件占满宽度 */
  setTimeout(() => nextTick(onResize), 100)
})
onUnmounted(() => window.removeEventListener('resize', onResize))
</script>

<style scoped>
.main-container {
  position: relative; /* 只是让内部绝对定位有参照，不影响 SVG */
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  padding: 2vw 0 0 0;
  gap: 2vw;

}
.content-item-text-bold{
  font-weight: bold;
}
.dash-line{
  stroke-width:2px;
}
.content-item-title{
  font-weight: normal;
  width: 100%;
  border-bottom: #cccccc 2px dashed;
  text-align: end;
}
.content-item-title-right{
  font-weight: normal;
  width: 100%;
  border-bottom: #cccccc 2px dashed;
}
.content-col {
  width: 35%;
  display: flex;
  flex-direction: column;
  justify-content: center;   /* 关键：居中排列 */
  gap: 1vw;                  /* 项与项间距 */
  height: 32vw;              /* 4×8vw + 3×1vw ≈ 35vw，可再微调 */
}
.left-col   { align-items: flex-end; }
.right-col  { align-items: flex-start;}

.content-item {
  width: 100%;
  height: 8vw;
  border-radius: 8px;
  position: relative;
  z-index: 2;
  transition: color 0.3s;
}
.content-item h3 {
  color: #666;
  margin: 0 0 8px;
  font-size: 1vw;
  transition: color 0.3s;
}
.content-item p {
  color: #999;
  font-size: 0.7vw;
  line-height: 1.6;
  margin: 0;
  width: auto;
  max-width: 100%;
  transition: color 0.3s;
}
.content-item.active h3 {
  color: #2ca6e0;
  border-color: #2ca6e0;
}
.content-item.active p {
  color: #333;
}
.item-icon {
  font-size: 22px;
  margin-right: 8px;
  vertical-align: middle;
}
/* 单独加大第二项下边距 */
.content-item.extra-gap {
  margin-bottom: 0vw;   /* PC：比 gap 多 1vw */
}
.ring-col {
  width: 30%;
  height: 32vw;
  display: flex;
  justify-content: center;
}
.dash-line-svg{
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}
/* ========== 移动端增量 @media ========== */
@media (max-width: 768px) {
  .main-container{
    position: relative; /* 只是让内部绝对定位有参照，不影响 SVG */
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto;
    padding: 2vw 0 0 0;
    gap: 2vw;
  }
  .content-col{
    height: 100vw;
  }
  /* 单独加大第二项下边距 */
  .content-item.extra-gap {
    margin-bottom: 0vw;   /* PC：比 gap 多 1vw */
  }
  .content-item h3 {
    color: #666;
    margin: 0 0 8px;
    font-size: 0.7rem;
    transition: color 0.3s;
    padding-bottom: 1px;
    line-height: 1.4;
  }
  .content-item p {
    color: #999;
    font-size: 6px;
    line-height: 1.4;
    margin: 0;
    width: auto;
    max-width: 100%;
    transition: color 0.3s;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 6;   /* 行数 */
    overflow: hidden;
  }
  .content-item-title{
    font-weight: normal;
    width: 100%;
    border-bottom: #cccccc 1px dashed;
    text-align: end;

  }

  .ring-col{
    height: 100vw;
  }
  .content-item-title-right{
    font-weight: normal;
    width: 100%;
    border-bottom: #cccccc 1px dashed;
  }
  .dash-line{
    width: 1px;
    stroke-width:1px;
    stroke-dasharray: 2 2;
  }
  .content-item {
    width: 100%;
    height: 25vw;
    border-radius: 8px;
    position: relative;
    z-index: 2;
    transition: color 0.3s;
  }
}
</style>
